import DropdownListCoverage from "@/components/spatialAnalysis/spatialOutputAnalysis/coverageType/DropdownListCoverage";
import FieldCoverage from "@/components/spatialAnalysis/spatialOutputAnalysis/coverageType/FieldCoverage";
import { COVERAGE_TYPE } from "@/components/spatialAnalysis/spatialOutputAnalysis/data";
import Dropdown from "@/components/ui/dropdown";
import type { IOptionItem } from "@/components/ui/dropdown/types";
import { MESSAGE } from "@/constants/message";
import { EOutputCoverageType } from "@/types/spatial";

interface CoverageTypeSectionProps {
  selectedCoverageType?: IOptionItem;
  valueCatchment: number | null;
  onHandleChangeCoverageType: (value: IOptionItem | null) => void;
  onHandleCatchment: (value: number | null) => void;
}

const CoverageTypeSection = ({
  selectedCoverageType,
  valueCatchment,
  onHandleChangeCoverageType,
  onHandleCatchment
}: CoverageTypeSectionProps) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-txtHeading font-sans font-semibold text-sm">
        Coverage Type
      </span>

      <Dropdown
        placeholder=""
        value={selectedCoverageType}
        data={COVERAGE_TYPE}
        onSelect={onHandleChangeCoverageType}
        renderOption={DropdownListCoverage}
      />

      {selectedCoverageType?.value === EOutputCoverageType.CUSTOM_CATCHMENT && (
        <FieldCoverage
          value={valueCatchment}
          max={100000}
          placeHolder={MESSAGE.COVERAGE_TYPE.PLACEHOLDER_TYPE_RADIUS}
          testId="coverage-radius-input"
          onChange={onHandleCatchment}
        />
      )}
    </div>
  );
};

export default CoverageTypeSection;
